(function ($) {

    // set up state for mobile
    ssm.addState({
        id: "mobile",
        maxWidth: 990,
        onEnter: function () {
            $("#search-form").hide();
            $("#show-search").on("click", function (e) {
                $("#search-form").show();
            });
            $("#hide-search").on("click", function (e) {
                $("#search-form").hide();
            });
        },
        onLeave: function () {
            $("#search-form").show();

        }
    });

    ssm.addState({
        id: "colorboxResizeTrigger",
        maxWidth: 600
    });

    var resizeTimer;
    resizeColorBox = function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            if (($('#cboxOverlay').is(':visible')) && (ssm.isActive('colorboxResizeTrigger'))) {
                $.colorbox.resize({ width: '95%', height: '400px' })
            } else if ($('#cboxOverlay').is(':visible')) {
                $.colorbox.resize({ width: '600px', height: '400px' })
            }
        }, 300)
    }

    // Resize Colorbox when resizing window or changing mobile device orientation
    $(window).resize(resizeColorBox);
    window.addEventListener("orientationchange", resizeColorBox, false);

    function showVideoOverlay(url) {
        $.colorbox({
            href: url,
            height: '95%',
            width: '95%',
            maxWidth: '600px',
            maxHeight: '400px',
            iframe: true,
            onLoad: function () {
                $("html").css("overflow", "hidden")
            },
            onClosed: function () {
                $("html").css("overflow", "initial")
            }
        });
    }


    $(document).ready(function () {
        $(".youtube-colorbox").on("click", function (e) {
            e.preventDefault();
            showVideoOverlay(this.href);
        });
    });


    (function (w) {
        w.addEventListener('load', function () {
            const content = document.getElementById('sub-menu');
            if (!content)
                return;

            const content_scroll_width = content.scrollWidth;
            let content_scroll_left = content.scrollLeft;

            const btn_left = document.getElementById('btn-left'),
                btn_right = document.getElementById('btn-right');

            btn_right.addEventListener('click', () => {
                content_scroll_left += 200;
                if (content_scroll_left >= content_scroll_width) {
                    content_scroll_left = content_scroll_width;
                    btn_right.classList.add("disabled");
                }
                content.scrollLeft = content_scroll_left;
                btn_left.classList.remove("disabled");
            });
            btn_left.addEventListener('click', () => {
                content_scroll_left -= 200;
                if (content_scroll_left <= 0) {
                    content_scroll_left = 0;
                    btn_left.classList.add("disabled");
                }
                content.scrollLeft = content_scroll_left;
                btn_right.classList.remove("disabled");
            });
        });
    })(window);

})(jQuery);